window.addEventListener('alpine:init', () => {
  function predictiveSearch(data = {}) {
    return {
      ...data,

      isLoadingPredictiveSearch: false,

      isOpenPredictiveSearch: false,

      isRendered: false,

      submit() {
        if (this.isLoadingPredictiveSearch) return;

        if (!this.q) {
          return this.isOpenPredictiveSearch = this.isRendered = false;
        }

        this.isLoadingPredictiveSearch = true;

        var url = new URL(`${location.origin}${window.global.routes.predictive_search_url}`);

        url.searchParams.set('q', this.q);
        url.searchParams.set('section_id', this.sectionId);

        var fetchOptions = {
          method: this.$el.method,
          body: this.formData
        };

        fetch(url, fetchOptions)
          .then((res) => {
            if (!res.ok) {
              throw new Error();
            }

            return res.text();
          })
          .then((res) => {
            dispatchEvent(new CustomEvent('predictivesearchsubmit', { detail: { html: res } }));
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.isLoadingPredictiveSearch = false;
          });
      },

      render(event) {
        this.$el.innerHTML = event.detail.html;
        this.isOpenPredictiveSearch = this.isRendered = true;
      },

      onFocusInput() {
        if (!this.isOpenPredictiveSearch && this.isRendered) {
          this.isOpenPredictiveSearch = true;
        }
      },

      reset() {
        this.$nextTick(() => {
          if (this.isOpenPredictiveSearch) {
            this.q = '';
            this.submit();
          }
        });
      }
    };
  };

  Alpine.data('predictiveSearch', predictiveSearch);
});
